/**
 * Remote Support, support side
 *
 * This script gets used on the support side of the remote support
 * It receives the connection from the client and handles the connection
 * It shows all logs in a table.
 *
 * It starts working when the user is on the /remote-support page
 */

jQuery(document).ready(function($) {
    // Check if the user is on the remote support page

    const remoteSupportMetaTag = $('meta[name="remote-support"]');
    if (remoteSupportMetaTag.length === 0) {
        return;
    }

    if (window.location.pathname === '/remote-support') {
        (async () => {
            // Setup PeerJs
            await remoteSupport.setupPeerJs();


            // Get the meta-tag content
            let metaTagContent = remoteSupportMetaTag.attr('content');

            // Split the content by comma
            let metaTagContentSplit = metaTagContent.split(',');
            // // Get the client peer id
            // let clientPeerId = metaTagContentSplit[0];
            // Get the remote support client peer id
            let remoteSupportClientPeerId = metaTagContentSplit[1];

            // Init the support
            remoteSupport.initSupport(remoteSupportClientPeerId);


        })();
    }
})

class RemoteSupport {
    async setupPeerJs() {
        // Add the PeerJs CDN to the header of the page
        jQuery('head').append('<script src="https://unpkg.com/peerjs@1.5.2/dist/peerjs.min.js"></script>');

        // Wait for the PeerJs CDN to load
        let attempts = 0;
        await new Promise((resolve, reject) => {
            const interval = setInterval(() => {
                if (typeof window.peerjs !== 'undefined') {
                    clearInterval(interval);
                    resolve();
                } else {
                    attempts++;
                    if (attempts > 10) {
                        clearInterval(interval);
                        console.error('PeerJs CDN could not be loaded');
                        reject();
                    }
                }
            }, 100);
        });
    }

    initSupport(remoteSupportClientPeerId: string) {
        this.selectBox = jQuery('#support-id');
        this.connectButton = jQuery('#connect');

        // Create a new PeerJs instance
        this.peer = new window.peerjs.Peer(remoteSupportClientPeerId);

        // When the PeerJs instance is ready
        this.peer.on('open', () => {
            console.log('PeerJs ready');
        });

        this.messages = JSON.parse(window.localStorage.getItem('remote-support-messages') || '[]');
        this.renderMessages();

        // Wait for new connections to get restored
        this.peer.on('connection', (conn) => {
            console.log('Connection received');
            // peer id should be in list of options of select box
            if (this.selectBox.find('option[value="' + conn.peer + '"]').length === 0) {
                console.warn('Peer id not found in select box, connection will be closed');
                conn.close();
            } else {
                // Select the peer id
                this.selectBox.val(conn.peer);
                this.handleConnection(conn);
            }
        });
    }

    receiveMessage(message: string) {
        if (!this.messages) {
            this.messages = [];
        }
        this.messages.push(JSON.parse(message));
        window.localStorage.setItem('remote-support-messages', JSON.stringify(this.messages));
        this.renderMessages();
    }

    renderMessages() {
        if (!this.messages) {
            this.messages = [];
        }
        // console.log({ messages: this.messages });
        let html = '';
        for (let i = 0; i < this.messages.length; i++) {
            const message = this.messages[i];
            // datetime should be written as d-m-Y H:i:s
            let received = new Date(message.timestamp);

            received = received.getDate() + '-' + leadingZero((received.getMonth() + 1)) + '-' + received.getFullYear() + ' ' + leadingZero(received.getHours()) + ':' + leadingZero(received.getMinutes()) + ':' + leadingZero(received.getSeconds());
            html += '<tr><td>' + message.type + '</td><td>' + JSON.stringify(message.data) + '</td><td>' + received + '</td></tr>';
        }
        jQuery('#logs tbody').html(html);

        if (this.messages.length > 0) {
            jQuery('#clear-messages').attr('disabled', false);
        } else {
            jQuery('#clear-messages').attr('disabled', true);
        }
    }

    clearMessages() {
        this.messages = [];
        window.localStorage.setItem('remote-support-messages', JSON.stringify(this.messages));
        this.renderMessages();
    }

    connect() {
        if (this.connection && this.connection.open) {
            this.connection.close();
            this.connection = null;
            return;
        }
        const selectBox = this.selectBox;
        const id = selectBox.val();

        this.handleConnection(this.peer.connect(id));
    }

    handleConnection(conn) {
        this.connection = conn;
        this.connection.on('open', () => {
            this.selectBox.attr('disabled', true);
            this.connectButton.html('Verbreek');

            // When a message is received
            this.connection.on('data', (data) => {
                this.receiveMessage(data);
            });

            // When the connection is closed
            this.connection.on('close', () => {
                this.selectBox.removeAttr('disabled');
                this.connectButton.html('Verbind');

            });
        });

        // prevent the window from closing
        window.onbeforeunload = function() {
            return "Are you sure you want to navigate away?";
        }
    }


}
const remoteSupport = new RemoteSupport();